import DOMPurify from 'dompurify'

/** HTML 문자열을 살균하여 XSS 공격을 방지한다 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty)
}
